// @ts-nocheck
import React from "react";
import { Transition } from "react-transition-group";

const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 0.5 },
    exited: { opacity: 0 },
};
const defaultDuration = 100;

interface Props {
    animate: boolean;
    children: React.ReactNode;
    delay?: number;
    appear?: boolean;
    duration?: number;
    unmountOnExit?: boolean;
    mountOnEnter?: boolean;
}

const FadeIn: React.FC<Props> = ({
    children,
    animate,
    delay = 0,
    duration = defaultDuration,
    appear = false,
    unmountOnExit = true,
    mountOnEnter = false,
}) => {
    const defaultStyle = {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
    };
    return (
        <Transition
            style={{
                display: "inherit",
                flexDirection: "inherit",
            }}
            mountOnEnter={mountOnEnter}
            in={animate}
            appear={appear}
            timeout={duration + delay}
            unmountOnExit={unmountOnExit}
        >
            {(state: keyof typeof transitionStyles) => (
                <div
                    style={{
                        display: "inherit",
                        flexDirection: "inherit",
                        justifyContent: "inherit",
                        alignItems: "inherit",
                        width: "inherit",
                        transitionDelay: String(delay),
                        ...defaultStyle,
                        ...transitionStyles[state],
                    }}
                >
                    {children}
                </div>
            )}
        </Transition>
    );
};

export default FadeIn;
